import { composeFetch } from '@library/http'
import {
  composeRequest,
  addPath,
  setServiceUrl,
  setMethod,
  goustoHeaders,
} from '@library/http/requests'

const parseMenuActivePeriodResponse = async (response: Response) => {
  const responseClone = await response.text()
  return JSON.parse(responseClone)
}

const menuActivePeriodRequest = composeRequest(
  setServiceUrl('menu', 1),
  addPath('active-periods'),
  goustoHeaders,
  setMethod('GET'),
)

export const menuActivePeriodsFetcher = composeFetch(
  menuActivePeriodRequest,
  parseMenuActivePeriodResponse,
)
